import { useNavigate } from '@hellodarwin/core/lib/features/providers/location-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useCallback } from 'react';
import { usePremiumAccess } from '../../../providers/premium-access-provider';
const useHandleLinkClick = ({ selectedKeys, }) => {
    const navigate = useNavigate();
    const { menuOpen, toggleMenu, app } = usePlatform();
    const { handleCheckout, isPageAccessible } = usePremiumAccess();
    return useCallback((link) => {
        if (!isPageAccessible(link.pathname) && app === 'client') {
            handleCheckout();
            return;
        }
        if (link.onClick)
            link.onClick();
        else if (!link.external_link) {
            if (menuOpen)
                toggleMenu();
            navigate(link.pathname);
        }
    }, [selectedKeys, navigate]);
};
export default useHandleLinkClick;
